module.exports = __webpack_public_path__ + "static/media/mic-off.99246803.svg";